import type { InsightCard } from "../aidwops.types";
import tooltipsData from "./AidwopsTooltips.json";
import InsightCardIcons from "./InsightCardIcon";
import "./InsightCards.scss";

function personaLabel(persona: string) {
    return persona === "zscaler"
        ? "Zscaler"
        : persona === "intune"
          ? "Intune"
          : persona;
}

const tooltips: Record<string, string> = tooltipsData.insights || {};

// No event-history pipeline exists yet (P1, confirmed scope) -- there is no
// real "vs yesterday" delta to show, so the mockup's sparkline/delta is
// intentionally left out rather than faked. Pill still reflects a real
// signal: a nonzero "gap" style metric (globally-scoped rules, apps with no
// rules, stale/noncompliant devices) reads as warn, everything else neutral.
const WARN_IDS = new Set([
    "zia_globally_scoped_rules",
    "zpa_apps_no_rules",
    "intune_stale_devices",
    "intune_os_below_minimum",
]);

export function InsightCards({
    cards,
    loading,
}: {
    cards: InsightCard[];
    loading?: boolean;
}) {
    return (
        <section>
            <div className="section-head">
                <span className="section-title">Top insights</span>
                <span className="section-sub">
                    Live, across selected agent(s)
                </span>
            </div>
            {/* <div className="insights-row">
                {loading &&
                    cards.length === 0 &&
                    Array.from({ length: 4 }).map((_, i) => (
                        <div key={i} className="skeleton-insight-card">
                            <div className="skeleton skeleton-line" />
                            <div className="skeleton skeleton-line" />
                        </div>
                    ))}
                {!loading && cards.length === 0 && (
                    <p className="section-sub">No insight data yet.</p>
                )}
                {cards.map((card) => {
                    const warn = WARN_IDS.has(card.id) && card.value > 0;
                    const tooltip =
                        tooltips[card.id] ||
                        (card.source === "expert_queue" && card.queueId
                            ? tooltips[card.queueId]
                            : undefined);
                    return (
                        <div
                            key={card.id}
                            className="insight-card"
                            title={tooltip}
                        >
                            <div className="insight-top">
                                <span className="insight-label">
                                    {card.title}
                                </span>
                                <span
                                    className={`insight-pill ${warn ? "warn" : "neutral"}`}
                                >
                                    {personaLabel(card.persona)}
                                </span>
                            </div>
                            <span
                                className={`insight-value ${warn ? "warn" : ""}`}
                            >
                                {card.value}
                            </span>
                            {card.detail && (
                                <span className="insight-detail">
                                    {card.detail}
                                </span>
                            )}
                        </div>
                    );
                })}
            </div> */}
            <div className="insights-row">
                {loading &&
                    cards.length === 0 &&
                    Array.from({ length: 4 }).map((_, i) => (
                        <div key={i} className="skeleton-insight-card">
                            <div className="skeleton skeleton-line" />
                            <div className="skeleton skeleton-line" />
                        </div>
                    ))}
                {!loading && cards.length === 0 && (
                    <p className="section-sub">No insight data yet.</p>
                )}
                {cards.map((card) => {
                    const tooltip =
                        tooltips[card.id] ||
                        (card.source === "expert_queue" && card.queueId
                            ? tooltips[card.queueId]
                            : undefined);
                    return (
                        <div
                            key={card.id}
                            className="top-insights-card"
                            title={tooltip}
                        >
                            <div className="top-insights-card--top">
                                <div className="top-insights-card--top--icon">
                                    {InsightCardIcons[card.id] ??
                                        InsightCardIcons[card.persona]}
                                </div>
                                <div className="top-insights-card--top--info">
                                    <span
                                        className={`top-insights-card--top--info--persona`}
                                    >
                                        {personaLabel(card.persona)}
                                    </span>
                                    <span
                                        className={`top-insights-card--top--info--value`}
                                    >
                                        {card.value}
                                    </span>
                                </div>
                            </div>
                            <span className="top-insights-card--title">
                                {card.title}
                            </span>
                            {card.detail && (
                                <span className="top-insights-card--detail">
                                    {card.detail}
                                </span>
                            )}
                        </div>
                    );
                })}
            </div>
        </section>
    );
}
